// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__2ASBx","info":"PatientInfo_info__3jnyW"};